import { IResponse } from "models";

export enum ActionType {
  FACTOR_N_EFFECTS = "action/FACTOR_N_EFFECTS",
  FACTOR_N_EFFECTS_SUCCESS = "action/FACTOR_N_EFFECTS_SUCCESS",
  FACTOR_N_EFFECTS_ERROR = "action/FACTOR_N_EFFECTS_ERROR",
  FACTOR_N_EFFECTS_RESET = "action/FACTOR_N_EFFECTS_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IFactorsNEffectsPayload {
  year: string;
  month: string;
  designation: string;
  locale?: string;
}

export interface IFactorsNEffectsResponse extends IResponse {
  result: any;
}
